import { useState, useEffect } from 'react';
import { TextField, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ['link', 'image'],
    ['clean'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
  ],
};

export default function AddNotif({ onSave, data, razredi = [] }) {
  const [text, setText] = useState('');
  const [naslov, setNaslov] = useState('');
  const [idRazreda, setIdRazreda] = useState('');

  useEffect(() => {
    if (data.id) {
      setText(data.body || '');
      setNaslov(data.headline || '');
      setIdRazreda(data.id_razreda || '');
    }
  }, [data]);

  const handleSave = () => {
    if (onSave) {
      onSave({ id: data.id, headline: naslov, html: text, id_razreda: idRazreda });
    }
  };

  return (
    <div className="date-container">
      <TextField margin="normal" fullWidth label="Naslov objave" name="naslov"
        autoFocus placeholder="Unesite naslov objave"
        onChange={(e) => setNaslov(e.target.value)} value={naslov} />

      <FormControl variant="standard" style={{ width: '100%', marginBottom: 20, marginTop: 5 }}>
        <InputLabel style={{ fontWeight: 'bold' }}>Odaberite razred</InputLabel>
        <Select value={idRazreda} onChange={(e) => setIdRazreda(e.target.value)}>
          {razredi.map((type) => (
            <MenuItem value={type.id} key={type.id}>{type.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <ReactQuill
        value={text}
        onChange={setText}
        modules={modules}
        style={{ width: '100%', marginBottom: 10 }}
      />

      <Button type="submit" variant="contained" color="primary" onClick={handleSave}>
        Sačuvaj
      </Button>
    </div>
  );
}
